module.exports = __webpack_public_path__ + "static/media/ic-right-arrow.1e7d09b9.svg";